import "./style.css";
import { configureProductTour } from "./product-tour";
import { configureAndroidInterestForm } from "./android-interest-form";

configureAndroidInterestForm();
configureProductTour();

document.documentElement.classList.add("js");

const header = document.querySelector<HTMLElement>(".site-header");
const updateHeader = () => header?.classList.toggle("is-scrolled", scrollY > 24);
updateHeader();
addEventListener("scroll", updateHeader, { passive: true });

const year = document.querySelector<HTMLElement>("#year");
if (year) year.textContent = String(new Date().getFullYear());

const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
const reveals = document.querySelectorAll<HTMLElement>(".reveal");

if (reducedMotion || !("IntersectionObserver" in window)) {
  reveals.forEach((element) => element.classList.add("is-visible"));
} else {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "0px 0px -8%", threshold: 0.12 },
  );
  reveals.forEach((element) => observer.observe(element));
}
